export default __webpack_public_path__ + "static/media/label.7ebaa667.svg";